<div #wrapper class="weight-qty-wrapper">
    <app-modal-header [text]="externalMeal.title" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container>
        <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
            <div
                    *ngIf="externalMeal.by == 'WEIGHT'"
                    class="form-group row">
                <label class="col-sm-3 col-form-label">{{ 'gramaj' | localise }}:</label>
                <div class="col-sm-9">
                    <input class="form-control"
                           [(ngModel)]="externalMeal.weight"
                           min="1"
                           step="1"
                           type="number"/>
                </div>
            </div>

            <div
                    *ngIf="externalMeal.by == 'QTY'"
                    class="form-group row">
                <label class="col-sm-3 col-form-label">{{ 'quantity' | localise }}:</label>
                <div class="col-sm-9">
                    <input class="form-control"
                           [(ngModel)]="externalMeal.qty"
                           min="1"
                           step="1"
                           type="number"/>
                </div>
            </div>
        </div>

        <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
            <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
            <button type="button" class="btn btn-success" (click)="save()">{{ 'save' | localise }}</button>
        </div>
    </ng-container>
</div>
